export default __webpack_public_path__ + "static/media/unstaking-step-pkf.3b0290b3.png";